import axios from 'axios'

export const jwtClientAxios = () => {
  // 인터셉터가 설정된 기본 axios 인스턴스 사용
  // 토큰은 request 인터셉터에서 자동으로 추가됨
  return axios
}
